import { useDispatch, useSelector } from 'react-redux';

import ScreenshotAnnotator from 'components/shared/others/screenshot-annotator/screenshot-annotator';
import type { AnnotationNote } from 'components/shared/others/screenshot-annotator/screenshot-annotator';
import { ViewWrapper } from 'components/partials/insight-modal/shared/components';

import { setNotes as setNotesAction } from 'state/insight/insight.slice';

import type { RootState } from 'state/store';

interface AnnotateStepProps {
  imageUrl: string | null;
}

const AnnotateStep = ({ imageUrl }: AnnotateStepProps) => {
  const dispatch = useDispatch();
  const notes = useSelector((s: RootState) => s?.insight?.notes || []);
  const annotationNotes: AnnotationNote[] = notes.map((note) => ({
    id: note.id,
    xPct: note.xPct ?? 0,
    yPct: note.yPct ?? 0,
    text: note.text ?? '',
  }));

  return (
    <ViewWrapper>
      <ScreenshotAnnotator
        imageSrc={imageUrl}
        initialNotes={annotationNotes}
        onChange={(updated) => dispatch(setNotesAction(updated as typeof notes))}
      />
    </ViewWrapper>
  );
};

export default AnnotateStep;
